<template>
  <div>
    <div class="checkbox-list-item">
      <div class="checkbox checkbox-primary checkbox-list-item__checkbox">
        <input
          class="checkbox-list-item__checkbox"
          type="checkbox"
          name="opportunities[]"
          :value="option.id"
          :id="`checkbox-opportunity-${option.id}`"
          v-model="option.opted_in">

        <label :for="`checkbox-opportunity-${option.id}`">
          {{ option.label }}
        </label>
      </div>
      <div class="money">
        <span class="money__symbol">{{ moneySymbol }}</span>
        <input class="money__input" v-model="option.budget" :disabled="!option.opted_in" type="number" min="0"
               step="10"/>
      </div>
    </div>
    <div v-if="!validation.budget.required || !validation.budget.minValue" class="help-block">You must set a budget
    </div>
    <div v-else-if="budgetHint">{{ budgetHint }}</div>
  </div>
</template>

<script>
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  props: {
    option: {
      required: true
    },
    validation: {
      required: true
    },
    user: {
      required: true
    }
  },

  computed: {
    budgetHint () {
      if (!this.option.opted_in) { return null }

      const budgetHints = this.option.budget_hints
      const budgetHint = budgetHints.filter(element => element.low <= this.option.budget && (element.high > this.option.budget || element.high === null))[0]
      if (!budgetHint) {
        return null
      }
      return budgetHint[this.$user.role] ? budgetHint[this.$user.role] : budgetHint.default
    },

    moneySymbol () {
      if (this.user.region.currency_code === 'points') {
        return 'Pts'
      }
      return getSymbolFromCurrency(this.user.region.currency_code)
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  &__checkbox {
    flex-shrink: 0;
  }
}
</style>
